import { isDev } from './optimizedImports';

/**
 * Dev-only console logging. No-ops in production builds so the verbose
 * meeting/Jitsi diagnostics — and any payloads they include (tokens, config,
 * device info) — never reach end users' consoles.
 *
 * Use `console.warn` / `console.error` / `console.info` directly for genuine
 * runtime signals that should surface in production; use these helpers only
 * for developer-facing trace logging.
 */
export const devLog = (...args: unknown[]): void => {
  if (isDev) {
    console.log(...args);
  }
};

export const devDebug = (...args: unknown[]): void => {
  if (isDev) {
    console.debug(...args);
  }
};
